import type { SVGProps } from "react";
export default function SvgRedo(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			className="lucide lucide-redo2-icon lucide-redo-2"
			viewBox="0 0 24 24"
			{...props}
		>
			<path d="m15 14 5-5-5-5" />
			<path d="M20 9H9.5A5.5 5.5 0 0 0 4 14.5 5.5 5.5 0 0 0 9.5 20H13" />
		</svg>
	);
}
